import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { sizePage } from '../app.constants';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class RollCallService {

  private readonly prefixRollCall: string = "/roll";

  constructor(private readonly http: HttpClient) { }

  /**
   * Get list of roll calls
   * @param companyId Id of company 
   * @param clientName Full name of the client
   * @param currentPage Page number of the list of roll call
   * @returns A list of roll calls
   */
  public async getAllRollCall(companyId: string, currentPage: number, filters?: any): Promise<any> {
    currentPage--;
    //const url = `${this.prefixRollCall}/all?companyId=${companyId}&clientName=${clientName}&page=${currentPage}&size=${sizePage}`
    let url = `/assistance/event/self/all?filter=companyId::${companyId}&sort=registrationDate::desc&page=${currentPage}&size=${sizePage}`;
    if (filters) {
      url = `/assistance/event/self/all?filter=${filters}&sort=registrationDate::desc&page=${currentPage}&size=${sizePage}`;
    }

    console.log("url", url);
    
    return await this.http.get(url).toPromise();
  }

  

  public async getDataUser(userId: string): Promise<any> {
    //const url = `/assistance/event/self?id=${userId}`;7
    const url = `/assistance/event/self?id=${userId}`;
    const response = await this.http.get(url).toPromise();
    return response;
  }


  public async getAllValidationEvent(eventId: string): Promise<any> {
    //const url = `/assistance/event/self?id=${userId}`;7
    const url = `/assistance/validation/self/all?filter=eventId::${eventId}&sort=id::asc&page=0&size=10`;
    const response = await this.http.get(url).toPromise();
    return response;
  }

  public async setValidationManual(payload: any): Promise<any> {
    const url = `/assistance/validation/trigger`;
    const response = await this.http.post(url, payload).toPromise();
    return response;
  }


  public async getCoordinatesWrong(idEvent: any): Promise<any> {
    const url = `/assistance/event/self/thin?id=${idEvent}&content=location`;
    const response = await this.http.get(url).toPromise();
    return response;
  }

  public async getDataObject(idObject: string): Promise<any> {
    //const url = `/assistance/event/self?id=${userId}`;7
    const url = `/assistance/event/object?id=${idObject}`;
    const response = await this.http.get(url).toPromise();
    return response;
  }

  /**
   * Get data (details) from user
   * @param userId Id of user
   * @returns data from user
   */
  public getDataFromUser(userId: string): Observable<any> {
    return this.http.get(`${this.prefixRollCall}/object?id=${userId}`);
  }

  /**
   * Get report excel of roll calls
   * @param companyId Id of company 
   * @param clientName Full name of the client
   * @param currentPage Page number of the list of roll call
   * @returns A list of roll calls
   */
  public getReportExcel(filters?: any): Promise<any> {
    //const url = `${this.prefixRollCall}/report/xsls?companyId=${companyId}&clientName=${clientName}&page=0&size=${sizePageFilter}`;
    const url = `/assistance/event/report/event/all?filter=${filters}&sort=id::desc&page=0&size=5000`;
    const response = this.http.get(url).toPromise();
    return response;
  }

}
